__turbopack_context__.v({
  "code": "CodeContent-module__CUv8JG__code",
  "codeBlock": "CodeContent-module__CUv8JG__codeBlock",
  "container": "CodeContent-module__CUv8JG__container",
  "header": "CodeContent-module__CUv8JG__header",
  "headerActions": "CodeContent-module__CUv8JG__headerActions",
  "headerContainer": "CodeContent-module__CUv8JG__headerContainer",
  "name": "CodeContent-module__CUv8JG__name",
  "switchContainer": "CodeContent-module__CUv8JG__switchContainer",
  "switchContainerHidden": "CodeContent-module__CUv8JG__switchContainerHidden",
  "tabContainer": "CodeContent-module__CUv8JG__tabContainer",
});
